const axios = require('axios');

// TODO: To confirm the description is correct
/**
 * @name setOrders
 * @description Fetches user's orders' list and saves them in the store
 * @param {Object} crmId
 * @returns dispatch reducer
 */
export const setOrders = (crmId) =>{
  // console.log('actions/orders.js - 9 ==> crmId', crmId);
  // const request = fetch('http://localhost:9000/api/orders',
  //   {
  //     method: 'POST',
  //     body: JSON.stringify(email),
  //     headers: {'Content-Type': 'application/json'}
  //   }
  // );
  return (dispatch) => {
    dispatch({ type: 'SHOW_LOADING_OVERLAY', text: 'Loading'})
    axios.post('/api/orders', crmId)
    .then(function (response) {
      // console.log('actions/orders.js - 23 ==> response', response);
      dispatch(
        {
          type: 'SET_ORDERS',
          orders: response.data
        }
      );
      dispatch({ type: 'HIDE_LOADING_OVERLAY' });
    })
    .catch(function (error) {
      alert('OOPS! Something went wrong at actions/orders.js', error);
    });
  }

  // return (dispatch) => {
  //   request.then(response => {
  //     console.log('actions/orders.js - 30 ==> response', response);
  //     if(response.status === 500){
  //       alert('server error, try again later.')
  //     }
  //     else if(response.status === 200 && response.ok){

  //       response.json().then(data => {
  //         console.log('actions/orders.js - 37 ==> orders', response.data);
  //         dispatch(
  //           {
  //             type: 'SET_ORDERS',
  //             orders: data.orders
  //           }
  //         );

  //       })
  //       .catch(error => {
  //         alert('OOPS! Something went wrong');
  //       })
  //     }
  //   })
  //   .catch(error => {
  //     alert('OOPS! Something went wrong');
  //   })
  // }
};

export const changeOrderStatus = (id, username, status) =>{
  const request = fetch('/api/change-status',
    {
      method: 'POST',
      body: JSON.stringify({
        username,
        id,
        status,
      }),
      headers: {"Content-Type": "application/json"}
    }
  );

  return (dispatch) => {
    request.then(response => {
      if(response.status === 500){
        alert('server error, try again later.')
      }
      else if(response.status === 200){
        dispatch(
          {
            type: 'CHANGE_ORDER_STATUS',
            id,
            status
          }
        );
      }
    })
    .catch(error => {
      alert('OOPS! Something went wrong');
    })
  }
};

export const addOrder = (username) =>{
  let form = document.getElementById("entry").elements;
  let name = form[0].value;
  let od = form[1].value;
  let dd = form[2].value;
  let description = form[3].value;
  let total = form[4].value;
  let id = 0;

  if(name === "" || od === "" || dd === "" || description === ""|| total === ""){
    return () => {};
  }

  let orderObj = {
    _id: id,
    name,
    description,
    od,
    dd,
    total,
    status: 0
  }

  const request = fetch('/api/add-order',
    {
      method: 'POST',
      body: JSON.stringify({
        username: username,
        name,
        description,
        od,
        dd,
        total
      }),
      headers: {"Content-Type": "application/json"}
    }
  );


  return (dispatch) => {
    request.then(response => {
      orderObj._id = response;
      if(response.status === 500){
        alert('server error, try again later.')
      }
      else if(response.status === 200){
        dispatch(
          {
            type: "ADD_ORDER",
            payload: orderObj
          }
        );
      }
    })
    .catch(error => {
      alert('OOPS! Something went wrong');
    })
  }
};

export const deleteOrder = (id, username) =>{
  const request = fetch('/api/delete-order',
    {
      method: 'POST',
      body: JSON.stringify({
        id,
        username
    }),
      headers: {"Content-Type": "application/json"}
    }
  );

  return (dispatch) => {
    request.then(response => {
      if(response.status === 500){
        alert('server error, try again later.')
      }
      else if(response.status === 200){
        dispatch(
          {
            type: 'DELETE_ORDER',
            id: id
          }
        );
      }
    })
    .catch(error => {
      alert('OOPS! Something went wrong');
    })
  }
};

export const navigateToShopifyStatus = (order_id) => {
  return (dispatch) => {
    dispatch({ type: 'SHOW_LOADING_OVERLAY', text: 'Loading'})
    axios.get('https://middleware.apm-monaco.com/shopify/orders/status_page?id=' + order_id)
    .then(function (response) {
      dispatch({ type: 'HIDE_LOADING_OVERLAY' });
      window.open(response.data.msg)
    })
    .catch(function (error) {
      dispatch({ type: 'HIDE_LOADING_OVERLAY' });
      alert('OOPS! Something went wrong');
    });
  }
};



// WEBPACK FOOTER //
// ./src/redux/actions/orders.js